export const INITIAL_PRESENTATION_TEXT_VISIBILITY: boolean = true;
export const INITIAL_PRESENTATION_END_TEXT_VISIBILITY: boolean = false;
export const INITIAL_WORDING_VISIBILITY: boolean = false;
export const INITIAL_BAD_RESPONSE_CUMULATED = 0;
export const INITIAL_CARD_TO_FIND_VISIBILITY: boolean = false;
export const INITIAL_ARE_CARDS_IN_GAME_RETURN: boolean = false;
export const INITIAL_IS_MARK_ON_CARDS_IN_GAME_VISIBLE = false;
export const INITIAL_IS_GAME_FINISH = false;
export const INITIAL_IS_GAME_WIN = false;
export const INITIAL_IS_COUNT_DOWN_VISIBLE = false;
